import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Reveal } from "../components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function KontaktPage() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/kontakt`, form);
      setSent(true);
    } catch {
      toast.error("Deine Nachricht konnte nicht gesendet werden. Bitte versuche es erneut.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="pt-28 pb-24" data-testid="kontakt-page">
      <section className="py-14">
        <div className="max-w-xl mx-auto px-5">
          <Reveal>
            <p className="eyebrow-label mb-5">Kontakt</p>
            <h1 className="font-display font-medium tracking-tight text-4xl sm:text-5xl leading-[1.08] mb-4">
              Schreib uns <em style={{ color: "var(--terra)" }}>gerne.</em>
            </h1>
            <p className="text-[15px] text-[color:var(--ink-muted)] leading-relaxed mb-4">
              Fragen zu den Lernwelten, zum digitalen Lernpaket oder zum kommenden Ringbuch? Wir
              freuen uns auf deine Nachricht.
            </p>
            <p className="text-[15px] text-[color:var(--ink-muted)] mb-10">
              Direkt per E-Mail:{" "}
              <a href="mailto:hallo@visualma-lernwelten.de" className="font-semibold underline underline-offset-4" style={{ color: "var(--terra)" }} data-testid="kontakt-email-link">
                hallo@visualma-lernwelten.de
              </a>
            </p>
          </Reveal>
          {sent ? (
            <div className="card-soft p-8 text-center" data-testid="kontakt-success">
              <p className="font-display text-2xl mb-2">Danke für deine Nachricht!</p>
              <p className="text-sm text-[color:var(--ink-muted)]">Wir melden uns so bald wie möglich bei dir.</p>
            </div>
          ) : (
            <Reveal delay={0.1}>
              <form onSubmit={submit} className="space-y-4">
                <input className="field" required placeholder="Dein Name" value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="kontakt-name-input" />
                <input className="field" required type="email" placeholder="Deine E-Mail-Adresse" value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="kontakt-email-input" />
                <textarea className="field" required placeholder="Deine Nachricht" value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="kontakt-message-input" />
                <button className="btn-primary w-full sm:w-auto" disabled={busy} data-testid="kontakt-submit-button">
                  {busy ? "Wird gesendet…" : "Nachricht senden"}
                </button>
              </form>
            </Reveal>
          )}
        </div>
      </section>
    </main>
  );
}
